export default "__VITE_PUBLIC_ASSET__49110bb5__"